var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCopy(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.3566 7.85498H4.53796C3.45495 7.85498 2.57422 8.73572 2.57422 9.81872V19.6374C2.57422 20.7204 3.45495 21.6011 4.53796 21.6011H14.3566C15.4396 21.6011 16.3204 20.7204 16.3204 19.6374V9.81872C16.3204 8.73572 15.4396 7.85498 14.3566 7.85498Z",
    fill: "#FBC108",
    fillOpacity: 0.864583
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.2473 1.96375H10.4286C9.90777 1.96375 9.40828 2.17064 9.04001 2.53891C8.67174 2.90718 8.46484 3.40667 8.46484 3.92748V5.89122H16.3198C16.8406 5.89122 17.3401 6.09811 17.7084 6.46638C18.0766 6.83466 18.2835 7.33414 18.2835 7.85496V15.7099H20.2473C20.7681 15.7099 21.2676 15.503 21.6358 15.1347C22.0041 14.7665 22.211 14.267 22.211 13.7462V3.92748C22.211 3.40667 22.0041 2.90718 21.6358 2.53891C21.2676 2.17064 20.7681 1.96375 20.2473 1.96375Z",
    fill: "#FBC108",
    fillOpacity: 0.864583
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopy);
export default __webpack_public_path__ + "static/media/copy.bfccfe6a1634c877164439b24e785b23.svg";
export { ForwardRef as ReactComponent };